
(function($) {
    $(document).ready(function() {	
      	document.cookie = "SameSite=None;";
		theme.init();		
    });
    
	var theme = {
		bhargavTimeout: null,
		isSidebarAjaxClick: false,
		init: function() {
			this.afterBeforeSlider();
            this.menu();
            //this.newsletter();
            this.initInstagram();
            this.initRecommendation();
            this.qtychange();
		},

        afterBeforeSlider(){
            // Call & init
            $(document).ready(function(){
                $('.ba-slider').each(function(){
                var cur = $(this);
                // Adjust the slider
                var width = cur.width()+'px';
                cur.find('.resize img').css('width', width);
                // Bind dragging events
                drags(cur.find('.handle'), cur.find('.resize'), cur);
                });
            });
            
            // Update sliders on resize. 
            // Because we all do this: i.imgur.com/YkbaV.gif
            $(window).resize(function(){
                $('.ba-slider').each(function(){
                var cur = $(this);
                var width = cur.width()+'px';
                cur.find('.resize img').css('width', width);
                });
            });
            
            function drags(dragElement, resizeElement, container) {
                
                // Initialize the dragging event on mousedown.
                dragElement.on('mousedown touchstart', function(e) {
                
                dragElement.addClass('draggable');
                resizeElement.addClass('resizable');
                
                // Check if it's a mouse or touch event and pass along the correct value
                var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
                
                // Get the initial position
                var dragWidth = dragElement.outerWidth(),
                    posX = dragElement.offset().left + dragWidth - startX,
                    containerOffset = container.offset().left,
                    containerWidth = container.outerWidth();
            
                // Set limits
                minLeft = containerOffset + 10;
                maxLeft = containerOffset + containerWidth - dragWidth - 10;
                
                // Calculate the dragging distance on mousemove.
                dragElement.parents().on("mousemove touchmove", function(e) {
                    
                    // Check if it's a mouse or touch event and pass along the correct value
                    var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
                    
                    leftValue = moveX + posX - dragWidth;
                    
                    // Prevent going off limits
                    if ( leftValue < minLeft) {
                    leftValue = minLeft;
                    } else if (leftValue > maxLeft) {
                    leftValue = maxLeft;
                    }
                    
                    // Translate the handle's left value to masked divs width.
                    widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
                        
                    // Set the new values for the slider and the handle. 
                    // Bind mouseup events to stop dragging.
                    $('.draggable').css('left', widthValue).on('mouseup touchend touchcancel', function () {
                    $(this).removeClass('draggable');
                    resizeElement.removeClass('resizable');
                    });
                    $('.resizable').css('width', widthValue);
                }).on('mouseup touchend touchcancel', function(){
                    dragElement.removeClass('draggable');
                    resizeElement.removeClass('resizable');
                });
                e.preventDefault();
                }).on('mouseup touchend touchcancel', function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
                });
            }
 
        },
        menu:function(){
            setTimeout(function () {
                var headerBox = $("header").outerHeight();
                $('.mobile-nav-drawer').css("top", headerBox);
                $('[data-menu-bar]').click(function(){
                    $('.site-overlay').toggleClass('show').css("top", headerBox);
                    $(this).find('i').toggleClass('ion-md-close').toggleClass('ion-md-menu');
                    $('.mobile-nav-drawer').toggleClass('opened');
                    $('body').toggleClass('remove-scroll');
                });
            }, 200);
            $('.site-overlay').click(function(){
                $('.site-overlay').css("top", "0").removeClass('show');
                $('[data-menu-bar]').find('i').removeClass('ion-md-close').addClass('ion-md-menu');
                $('.mobile-nav-drawer').removeClass('opened');
                $('body').removeClass('remove-scroll');
            });
        },
        newsletter:function(){
            if(localStorage.getItem('popState') != 'shown'){
                $(".newsletter-popup").addClass('opened');
                $('.site-overlay').addClass('show');
                $('body').addClass('remove-scroll');
                //localStorage.setItem('popState','shown')
            }
            $('[data-newsletter-close-btn]').on('click',function(){
                localStorage.setItem('popState','shown');
                $(".newsletter-popup").removeClass('opened');
                $('.site-overlay').removeClass('show');
                $('body').removeClass('remove-scroll');
            });
        },
        initInstagram:function(){
            var User_Id = $("#instafeed").data("user-id");
            var Access_Token = $("#instafeed").data("access-token");
            var limit = $("#instafeed").data("limit");
            
            var userFeed = new Instafeed({
                get: 'user',
                accessToken: Access_Token,
                userId: User_Id,
                limit: 6,
                imageResolution: 'standard-resolution',
                template: '<div class="col-4 col-md-2"><a href="{{link}}" target="_blank" class="insta_item"><div class="insta_img"><img src="{{image}}" /></div></a></div>'
            });
            userFeed.run();
        },
        initRecommendation:function(){
    
            // sections.register('product-recommendations', theme.ProductRecommendations);
            // theme.ProductRecommendations = (function() {
            // function ProductRecommendations(container) {
            //     var $container = (this.$container = $(container));
            //     var productId = $container.data('productId');
            //     var limit = $container.data('limit');
            //     var productRecommendationsUrlAndContainerClass =
            //     '/recommendations/products?&section_id=product-recommendations&limit=' + limit + '&product_id=' + productId + ' .product-recommendations';
            //     $container.parent().load(productRecommendationsUrlAndContainerClass);
            // }
            // return ProductRecommendations;
            // })();
        },
        qtychange:function(){
            $('[data-qty-increase]').on('click',function(){
              var parent = $(this).closest(".quantity-wrapper");
              var input = $(parent).find('.product__qty');
              console.log(input);
              var qtyIn = parseInt($(input).val())
              $(input).val(qtyIn + 1);
            });
            
            $('[data-qty-decrease]').on('click',function(){
              var parent = $(this).closest(".quantity-wrapper");
              var input = $(parent).find('.product__qty');
              var qtyde = parseInt($(input).val())
              if(qtyde > 1){
                $(input).val(qtyde - 1);
              }
            });
        }  
	}    
})(jQuery);
